//Library Imports
import React, { useEffect, useState } from "react";
import { Col, Row } from "antd";
import store, { RootState } from "store";
import { useSelector } from "react-redux";
import styled from "styled-components";

//Local Imports
import ButtonRightIconGreen from "modules/Common/Components/ButtonRightIconGreen";
import ButtonRightIcon from "modules/Common/Components/ButtonRightIcon";
import Add from "../../../../assets/img/CuratedContent/Plus.svg";
import Import from "../../../../assets/img/icons/Import.svg";
import Send from "../../../../assets/img/CuratedContent/Send.svg";
import { closeOverlay, GLOBAL_ACTION, openCreateNewContactSidebar } from "modules/GlobalActions";
import { exportListDetails, resetAudienceListDetailsProfiled } from "./actions";
import { addGillRoyIcon, getQueryListId } from "utils";
import ExportPopup from "../Components/ExportPopup";
import FloatingSidebarTwo from "modules/Common/Components/FloatingSidebarTwo";
import CreateContactSidebar from "../People/CreateContactSidebar";
import FilterDropdownOrganization from "../People/FilterDropdownOrganization";
import FilterDropdownDesignation from "../People/FilterDropdownDesignation";
import FilterDropdownPersonality from "../People/FilterDropdownPersonality";
import FilterDropdownStatus from "../People/FilterDropdownStatus";
import {
  AUDIENCE_LISTS_DETAILS,
  AUDIENCE_LISTS_NON_PROFILED_CONTACTS,
  AUDIENCE_LISTS_PROFILED_CONTACTS,
} from "constants/types";
import AudienceSearchTab from "../Components/AudienceSearchTab";
import { getDesignations, getOrganizations } from "../actions";

interface IListDetailsTab {
  tabState: any;
  setTabState: (arg0: string) => void;
  showImportListAsider: boolean;
  setShowImportListAsider: (arg0: boolean) => void;
  updateTotalCount?: boolean;
  setUpdateTotalCount: (arg0: boolean) => void;
  selectedOrganization: string[];
  setSelectedOrganization: (arg0: string[]) => void;
  selectedDesignation: string[];
  setSelectedDesignation: (arg0: string[]) => void;
  selectedPersonalityType: string[];
  setSelectedPersonalityType: (arg0: string[]) => void;
  selectedStatus: string[];
  setSelectedStatus: (arg0: string[]) => void;
  resetFilters: () => void;
  clearFiltersCheck: boolean;
  setClearFiltersCheck: (arg0: boolean) => void;
  clearFiltersHandler: () => void;
  exportContactsFilterParams: any;
  exportPeopleFiltersUpdate: () => void;
  page: string;
}

const ListDetailsTab: React.FC<IListDetailsTab> = ({
  tabState,
  showImportListAsider,
  setShowImportListAsider,
  updateTotalCount,
  setUpdateTotalCount,
  selectedOrganization,
  setSelectedOrganization,
  selectedDesignation,
  setSelectedDesignation,
  selectedPersonalityType,
  setSelectedPersonalityType,
  selectedStatus,
  setSelectedStatus,
  clearFiltersHandler,
  exportContactsFilterParams,
  exportPeopleFiltersUpdate,
  page,
}) => {
  //Local States
  const [showCreateContactFormState, setshowCreateContactFormState] = useState(false);
  const [closeSidebarInstantly, setCloseSidebarInstantly] = useState(true);
  const [firstTimeLoad, setFirstTimeLoad] = useState(true);
  const [exportDisable, setExportDisable] = useState(false);

  //Redux States
  const campaignsAndAssetsCount = useSelector(
    (state: RootState) => state.audienceListDetails.campaignsAndAssetsCount
  );
  const totalContacts = useSelector((state: RootState) => state.audienceListDetails.totalContacts);
  const profiledLoading: boolean = useSelector((state: RootState) => state.audienceListDetails.profiled.loading);
  const profiled: any = useSelector((state: RootState) => state.audienceListDetails.profiled.data);
  const nonProfiled: any = useSelector((state: RootState) => state.audienceListDetails.nonProfiled.data);
  const nonProfiledLoading: boolean = useSelector(
    (state: RootState) => state.audienceListDetails.nonProfiled.loading
  );
  const showCreateContactForm = useSelector((state: RootState) => state.audience.showCreateContactForm);
  const disableExportButton = useSelector((state: RootState) => state.audienceLists.exportLoading);
  const audienceFiltersApplied: boolean = useSelector(
    (state: RootState) => state.uiReducer.audienceFiltersApplied
  );
  const searchTermListContacts = useSelector(
    (state: RootState) => state.audienceListDetails.searchTermListDetails
  );

  const importListButtonHandler = () => {
    setShowImportListAsider(!showImportListAsider);
    store.dispatch({
      type: GLOBAL_ACTION.IMPORT_LIST_POPOVER,
      payload: { importListAsiderState: true },
    });
    if (window.location.pathname.startsWith("/audiences")) {
      addGillRoyIcon()
    }
  };
  const closeSidebarInstantlyHandler = (showCreateContactForm: boolean) => {
    setshowCreateContactFormState(showCreateContactForm);
    closeOverlay();
  };

  useEffect(() => {
    if (!firstTimeLoad) {
      if (!showCreateContactForm) {
        closeSidebarInstantly
          ? closeSidebarInstantlyHandler(showCreateContactForm)
          : setshowCreateContactFormState(showCreateContactForm);
      } else {
        setshowCreateContactFormState(showCreateContactForm);
      }
    } else {
      setFirstTimeLoad(false);
    }
  }, [showCreateContactForm]);

  useEffect(() => {
    if (
      (profiled.length <= 0 && profiledLoading) ||
      (nonProfiled.length <= 0 && nonProfiledLoading) ||
      disableExportButton
    )
      setExportDisable(true);
    else if (totalContacts > 0) setExportDisable(false);
    else setExportDisable(true);
  }, [profiledLoading, nonProfiledLoading, disableExportButton, totalContacts]);

  useEffect(() => {
    setUpdateTotalCount(true);
    store.dispatch({
      type: AUDIENCE_LISTS_DETAILS.RESET_TOTAL_COUNT,
    });
  }, [tabState]);

  useEffect(() => {
    if (updateTotalCount) {
      setUpdateTotalCount(false);
    }
  }, [totalContacts]);

  useEffect(() => {
    if (!profiledLoading && updateTotalCount) setUpdateTotalCount(false);
  }, [profiledLoading]);

  const ApplyFiltersHandler = () => {
    resetAudienceListDetailsProfiled(); // reset contacts in list
    exportPeopleFiltersUpdate();
    store.dispatch({
      type: AUDIENCE_LISTS_PROFILED_CONTACTS.SET_FILTERS,
      filters: {
        designations: selectedDesignation,
        organizations: selectedOrganization,
        personality: selectedPersonalityType,
        status: selectedStatus,
      },
    });
    store.dispatch({
      type: GLOBAL_ACTION.APPLY_AUDIENCE_FILTERS,
    });
    if (!audienceFiltersApplied) {
      store.dispatch({
        type: GLOBAL_ACTION.AUDIENCE_FILTERS_APPLIED,
        payload: true,
      });
    }
  };

  return (
    <Wrapper>
      <Row>
        <Col span={16} className="audience-list-search">
          <AudienceSearchTab page={page} isProfiled={true} />
        </Col>
        <Col className="gutter-row" span={8}>
          <div
            className="d-flex flex-row-reverse ant-space ant-space-horizontal ant-space-align-center"
            style={{ height: "100%" }}
          >
            <ButtonRightIcon label="Import a list" icon={Import} onClick={importListButtonHandler} />
            <span onClick={() => openCreateNewContactSidebar()} className="me-3">
              <ButtonRightIconGreen
                label="Create new contact"
                icon={Add}
                classIcon="plus15"
                className="list-green-btn"
                idBtn="list-green-btn-contact"
              />
            </span>
            <span className="me-3">
              <ButtonRightIcon
                label="Export"
                disable={exportDisable}
                onClick={() => {
                  exportListDetails(
                    {
                      export: true,
                      profiled: tabState === "profiled" ? "1" : "0",
                      ...exportContactsFilterParams,
                      searchTermListContacts: searchTermListContacts,
                    },
                    getQueryListId()
                  );
                }}
                icon={Send}
                outlineClass="auto-width"
              />
            </span>
          </div>
        </Col>
      </Row>

      <Row gutter={12} className="mt-3 filter-row">
        <Col span={2.5}>
          <FilterDropdownOrganization
            selectedOrganization={selectedOrganization}
            setSelectedOrganization={setSelectedOrganization}
            tabState={tabState}
          />
        </Col>
        <Col span={2.5}>
          <FilterDropdownDesignation
            selectedDesignation={selectedDesignation}
            setSelectedDesignation={setSelectedDesignation}
            tabState={tabState}
          />
        </Col>
        <Col className={`${tabState === "unprofiled" ? "disabled-filter" : ""}`} span={2.5}>
          <FilterDropdownPersonality
            selectedPersonalityType={selectedPersonalityType}
            setSelectedPersonalityType={setSelectedPersonalityType}
          />
        </Col>
        <Col span={2.5}>
          <FilterDropdownStatus selectedStatus={selectedStatus} setSelectedStatus={setSelectedStatus} />
        </Col>
        <Col span={2.5}>
          <ButtonRightIconGreen
            hidden={
              !(
                selectedOrganization.length > 0 ||
                selectedDesignation.length > 0 ||
                selectedPersonalityType.length > 0 ||
                selectedStatus.length > 0
              )
            }
            onClick={ApplyFiltersHandler}
            label="Apply Filters"
            marginTop="0px"
            noIcon
            className="list-apply-filters"
          />
        </Col>
        <Col
          hidden={
            !(
              selectedOrganization.length > 0 ||
              selectedDesignation.length > 0 ||
              selectedPersonalityType.length > 0 ||
              selectedStatus.length > 0
            )
          }
          span={2.5}
          className="clear-text"
        >
          <span onClick={clearFiltersHandler}>Clear all</span>
        </Col>

        <Col
          span={
            selectedOrganization.length > 0 ||
              selectedDesignation.length > 0 ||
              selectedPersonalityType.length > 0 ||
              selectedStatus.length > 0
              ? 13
              : 16
          }
          className="count-col"
        >
          {updateTotalCount || (profiledLoading && profiled.length === 0) ? (
            <div className="d-flex flex-row-reverse count">{"Fetching Count..."}</div>
          ) : (
            <div className="d-flex flex-row-reverse count">{`${totalContacts} Total`}</div>
          )}
        </Col>
      </Row>

      <Row gutter={8} className="mt-2">
        <Col className="gutter-row" span="12">
          <div className="d-flex campaign-asset-count-text">Campaigns and emails using this list</div>
        </Col>
        <Col className="gutter-row" span="12">
          <div className="d-flex flex-row-reverse count">{campaignsAndAssetsCount} link(s)</div>
        </Col>
      </Row>

      <ExportPopup listId={getQueryListId()} tabState={tabState} />
      <FloatingSidebarTwo isToggle={showCreateContactFormState}>
        <CreateContactSidebar
          selectedTab={tabState}
          setCloseSidebarInstantly={setCloseSidebarInstantly}
          listId={getQueryListId()}
        />
      </FloatingSidebarTwo>
    </Wrapper>
  );
};

export default ListDetailsTab;

const Wrapper = styled.div`
  margin-top: 0px;
  /* margin-bottom: 10px; */
  .filter-row {
    position: relative;
    .count-col {
      position: absolute;
      right: 0;
      margin-top: 5px;
      /* @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        margin-top: 0px;
      } */
    }
  }
  .clear-text {
    color: #7e7e7e;
    font-family: "Roboto";
    font-size: 14px;
    font-weight: 500;
    display: flex;
    align-items: center;
    cursor: pointer;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 12px;
    }
  }
  .disabled-filter {
    pointer-events: none;
    opacity: 0.5;
  }
  .campaign-asset-count-text {
    font-size: 23px;
    font-weight: 700;
    font-family: "Roboto Slab", serif;
    display: inline-block;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #424b50;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 16px;
    }
  }
  .total-count {
    height: 100%;
    align-items: center;
    color: #7e7e7e;
    font-family: "Roboto Slab", serif;
    font-size: 16px;
    font-weight: 500;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 14px;
    }
  }
  .count {
    align-items: center;
    color: #7e7e7e;
    font-family: "Roboto Slab", serif;
    font-size: 16px;
    font-weight: 500;

    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 14px;
    }
  }
  .plus-btn {
    margin-top: 0px;
  }
  .filters-tabs {
    ul {
      list-style-type: none;
      padding: 0;
      margin: 0;
      display: flex;
      li {
        margin: 0px;
        padding: 0;

        &:nth-child(1) {
          button {
            border-radius: 8px 0px 0px 8px;
            .wrapper {
              border-radius: 8px 0px 0px 8px;
            }
          }
        }
        &:nth-child(2) {
          button {
            border-radius: 0 8px 8px 0;
            .wrapper {
              border-radius: 0 8px 8px 0;
            }
          }
        }
      }
    }
  }
  .list-green-btn {
    white-space: nowrap;
  }
  /* .list-green-btn {
    width: 202px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      width: 168px;
    }
    @media all and (max-width: 1125px) {
      height: 26px;
    }
  } */
  .audience-list-search {
    .search-wraper {
      .search-bar {
        width: calc(100% - 25px);
        @media all and (max-width: 1700px) {
          width: calc(100% - 50px);
        }
        @media all and (max-width: 1650px) {
          width: calc(100% - 75px);
        }
        @media all and (max-width: 1550px) {
          width: calc(100% - 120px);
        }
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          width: calc(100% - 100px);
        }
        @media all and (max-width: 1260px) {
          width: calc(100% - 140px);
        }
      }
    }
  }
  .list-apply-filters {
    padding: 5px 2px 5px 16px;
  }
`;
